<template>

  <div class="box-login">
    <DashboardTitle title="Cambia tu contraseña" description="Para cambiar tu contraseña, por favor completa ambos campos, considerando las siguientes reglas y deben coincidir entre ellas:"></DashboardTitle>
    <div class="container">
      <div class="row row-responsive">
        <div class="column column-offset-sm-10 column-sm-33">
          <p>Tu nueva contraseña debe seguir las siguientes reglas de seguridad para transacciones en <b class="-green">Cumplo</b>:</p>
          <PasswordRules></PasswordRules>
        </div>
        <div class="column column-offset-sm-10 column-sm-40">
          <div class="box-password">
            <input :type="password" placeholder="Contraseña" v-model="user.firstPassword">
            <span @click="changeType()" class="togglepassword">
              <img src="https://icongr.am/fontawesome/eye-slash.svg?color=9b9b9b&size=18" v-if="password === 'password'">
              <img src="https://icongr.am/fontawesome/eye.svg?color=00C569&size=18" v-if="password === 'text'">
            </span>
          </div>
          <div class="box-password">
            <input :type="password" placeholder="Repetir contraseña" v-model="user.lastPassword">
            <span @click="changeType()" class="togglepassword">
              <img src="https://icongr.am/fontawesome/eye-slash.svg?color=9b9b9b&size=18" v-if="password === 'password'">
              <img src="https://icongr.am/fontawesome/eye.svg?color=00C569&size=18" v-if="password === 'text'">
            </span>
          </div>
          <p class="-centered-info">
            <button class="button" :disabled="user.firstPassword === '' || user.lastPassword === '' || resetPasswordStatus || status.email === true" @click="sendResetPassword()">Enviar</button>
          </p>
          <transition name="fade">
            <p class="message" v-if="resetPasswordStatus">Las claves no coinciden.</p>
          </transition>
          <transition name="fade">
            <div class="password-success" v-if="status.email">
              <CheckmarkOK></CheckmarkOK>
              <p>Tu contraseña ha sido modificada exitosamente.</p>
            </div>
          </transition>
          <p class="-centered-info">¿Recordaste tu contraseña?</p>
          <button class="button button-secondary button-fullwidth" @click.prevent="$router.push('/login')">¡Inicia sesión ahora!</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import DashboardTitle from '@/components/SignedTitle'
import CheckmarkOK from '@/components/CheckmarkOK'
import PasswordRules from '@/partials/PasswordRules'

import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'ResePassword',
  metaInfo () {
    return {
      title: 'Ingresa a tu cuenta | Cumplo'
    }
  },
  components: {
    DashboardTitle,
    PasswordRules,
    CheckmarkOK
  },
  mixins: [mixins, httpRequestMixin],
  data () {
    return {
      user: {
        firstPassword: '',
        lastPassword: '',
        token: null
      },
      status: {
        email: false
      },
      password: 'password'
    }
  },
  computed: {
    resetPasswordStatus: function () {
      return this.user.firstPassword !== this.user.lastPassword
    }
  },
  created: function () {
    this.user.token = this.$route.params.token
  },
  methods: {
    changeType: function () {
      this.password === 'password'
        ? this.password = 'text' : this.password = 'password'
    },
    beforeOpenResetPasswordModal: function () {
      this.user.firstPassword = ''
      this.user.lastPassword = ''
    },
    closeUserResetPasswordModal: function () {
      this.$router.replace({ name: 'LogIn' })
    },
    sendResetPassword: async function () {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/auth/password-reset/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          'token': this.user.token,
          'password': this.user.firstPassword,
          'password_confirmation': this.user.lastPassword
        }
      }

      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.status.email = true
      } else {
        const message = this.convertArraytoString(response.data)
        this.modalError(message, 'warning')
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.box-login {
  margin-top: 10rem;
  padding: 5rem 0;
  min-height: 450px;

  > .container {
    margin-top: 4rem;
  }

  .title {
    margin-bottom: 4rem;
    font-size: 2em;
    text-align: center;
    font-weight: 100;
  }

  .subtitle {
    font-size: 1.8em;
  }

  .icons {
    text-align: center;

    > img {
      margin: 0 1.5rem;
    }
  }

  .errormessage {
    color: $red;
    font-size: .9em;
    text-align: center;
  }
}

.box-password {
  position: relative;

  .togglepassword {
    cursor: pointer;
    position: absolute;
    right: 10px;
    color: #9b9b9b;
    top: 5px;
    font-size: 2rem;
  }
}

.message {
  font-size: .9em;
  color: $red;
  text-align: center;
}

.password-success {
  margin-bottom: 4rem;

  > p {
    line-height: 1;
    padding: 5px 0 0;
    text-align: center;
    color: $green;
    font-weight: bold;
  }

  .checkmark {
    float: left;
    margin: 0 2rem 0;
    width: 40px;
    height: 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue